var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderLineOfMeetorbix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 53,
    viewBox: "0 0 181 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00036 32.4574C15.0214 29.2481 22.4027 28.4241 28.8144 27.1083C54.589 21.8187 80.7373 18.4877 106.801 17.8578C128.553 17.3322 150.742 17.6488 172.3 20.4142",
    stroke: "#FFC738",
    strokeWidth: 17,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderLineOfMeetorbix);
export default __webpack_public_path__ + "static/media/under-line-of-meetorbix.4a82cb034461e26bff84e15cb4bab234.svg";
export { ForwardRef as ReactComponent };